import { useState } from 'react';
import { Moon, Sun, MonitorSmartphone } from 'lucide-react';
import { applyTheme, cycleTheme, readTheme, type ThemeMode } from '@/lib/theme';

const LABEL: Record<ThemeMode, string> = {
  light: 'Tema claro',
  dark: 'Tema oscuro',
  system: 'Tema del sistema',
};

export function ThemeToggle() {
  const [mode, setMode] = useState<ThemeMode>(() => {
    const stored = readTheme();
    applyTheme(stored);
    return stored;
  });

  return (
    <button
      type="button"
      onClick={() => setMode(cycleTheme(mode))}
      aria-label={LABEL[mode]}
      title={LABEL[mode]}
      className="flex h-11 w-11 items-center justify-center rounded-md text-neutral-600 transition-colors hover:bg-neutral-100 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--color-focus-ring)]"
    >
      {mode === 'dark' ? (
        <Moon className="h-4 w-4" aria-hidden="true" />
      ) : mode === 'light' ? (
        <Sun className="h-4 w-4" aria-hidden="true" />
      ) : (
        <MonitorSmartphone className="h-4 w-4" aria-hidden="true" />
      )}
    </button>
  );
}
